const orgBusinessScope = [
  { text: '农、林、牧、渔业', value: '农、林、牧、渔业' },
  { text: '采矿业', value: '采矿业' },
  { text: '制造业', value: '制造业' },
  { text: '电力、燃气及水的生产和供应业', value: '电力、燃气及水的生产和供应业' },
  { text: '建筑业', value: '建筑业' },
  { text: '交通运输、仓储和邮政业', value: '交通运输、仓储和邮政业' },
  { text: '信息传输、计算机服务和软件业', value: '信息传输、计算机服务和软件业' },
  { text: '批发和零售业', value: '批发和零售业' },
  { text: '住宿和餐饮业', value: '住宿和餐饮业' },
  { text: '金融业', value: '金融业' },
  { text: '房地产业', value: '房地产业' },
  { text: '租赁和商务服务业', value: '租赁和商务服务业' },
  { text: '科学研究、技术服务和地质勘查业', value: '科学研究、技术服务和地质勘查业' },
  { text: '水利、环境和公共设施管理业', value: '水利、环境和公共设施管理业' },
  { text: '居民服务和其他服务业', value: '居民服务和其他服务业' },
  { text: '教育', value: '教育' },
  { text: '卫生、社会保障和社会福利业', value: '卫生、社会保障和社会福利业' },
  { text: '文化、体育和娱乐业 ', value: '文化、体育和娱乐业 ' },
  { text: '公共管理与社会组织', value: '公共管理与社会组织' },
  { text: '国际组织 ', value: '国际组织 ' },
];
export default orgBusinessScope;
